// Templates to quickly populate an energy-company demo (IPP development + EPC procurement + basic O&M view)

export const categories = [
  { id: 'cat-energy', name: 'Equipos Energía', type: 'material', budgetCategory: 'materiales_principales' },
  { id: 'cat-electric', name: 'Materiales Eléctricos', type: 'material', budgetCategory: 'materiales_principales' },
  { id: 'cat-automation', name: 'Automatización y Control', type: 'material', budgetCategory: 'materiales_principales' },
  { id: 'cat-services', name: 'Servicios Técnicos', type: 'servicio', budgetCategory: 'servicios_menores' },
  { id: 'cat-engineering', name: 'Ingeniería y Desarrollo', type: 'servicio', budgetCategory: 'subcontratos' }
];

export const parks = [
  {
    id: 'park-leyda',
    name: 'Parque Solar Leyda (EPC)',
    code: 'PK-LYD',
    managerId: null,
    packages: [
      { id: 'pkg-leyda-civil', code: 'WBS-CIV', name: 'BoP Civil' },
      { id: 'pkg-leyda-elec', code: 'WBS-ELEC', name: 'BoP Eléctrico' },
      { id: 'pkg-leyda-scada', code: 'WBS-SCADA', name: 'SCADA & Comunicaciones' },
      { id: 'pkg-leyda-sub', code: 'WBS-SET', name: 'Subestación & Interconexión' }
    ],
    areas: [
      { id: 'park-leyda-const', name: 'Construcción', costCenterId: 'cc-1001', areaManagerId: null },
      { id: 'park-leyda-oper', name: 'Operación', costCenterId: 'cc-1002', areaManagerId: null }
    ],
    team: {
      projectManagerId: null,
      administrators: [],
      controllerId: null,
      fieldTeam: [],
      areaManagers: []
    }
  },
  {
    id: 'park-hurtado',
    name: 'Parque Solar Hurtado (EPC)',
    code: 'PK-HRT',
    managerId: null,
    packages: [
      { id: 'pkg-hurtado-civil', code: 'WBS-CIV', name: 'BoP Civil' },
      { id: 'pkg-hurtado-elec', code: 'WBS-ELEC', name: 'BoP Eléctrico' },
      { id: 'pkg-hurtado-scada', code: 'WBS-SCADA', name: 'SCADA & Comunicaciones' }
    ],
    areas: [
      { id: 'park-hurtado-const', name: 'Construcción', costCenterId: 'cc-2001', areaManagerId: null },
      { id: 'park-hurtado-oper', name: 'Operación', costCenterId: 'cc-2002', areaManagerId: null }
    ],
    team: {
      projectManagerId: null,
      administrators: [],
      controllerId: null,
      fieldTeam: [],
      areaManagers: []
    }
  }
];

export const costCenters = [
  { id: 'cc-1001', code: 'CC-1001', name: 'Construcción Leyda', parkId: 'park-leyda', areaId: 'park-leyda-const', description: 'EPC construcción' },
  { id: 'cc-1002', code: 'CC-1002', name: 'Operación Leyda', parkId: 'park-leyda', areaId: 'park-leyda-oper', description: 'O&M operación' },
  { id: 'cc-2001', code: 'CC-2001', name: 'Construcción Hurtado', parkId: 'park-hurtado', areaId: 'park-hurtado-const', description: 'EPC construcción' },
  { id: 'cc-2002', code: 'CC-2002', name: 'Operación Hurtado', parkId: 'park-hurtado', areaId: 'park-hurtado-oper', description: 'O&M operación' }
];

export const projectBudgets = [
  {
    parkId: 'park-leyda',
    currency: 'USD',
    total: 20000000,
    allocations: [
      { id: 'budget-leyda-main', name: 'Materiales principales', category: 'materiales_principales', amount: 10000000 },
      { id: 'budget-leyda-subcontracts', name: 'Subcontratos', category: 'subcontratos', amount: 5000000 },
      { id: 'budget-leyda-services', name: 'Servicios menores', category: 'servicios_menores', amount: 3000000 },
      { id: 'budget-leyda-other', name: 'Otros', category: 'otros', amount: 2000000 }
    ]
  },
  {
    parkId: 'park-hurtado',
    currency: 'USD',
    total: 15000000,
    allocations: [
      { id: 'budget-hurtado-main', name: 'Materiales principales', category: 'materiales_principales', amount: 8000000 },
      { id: 'budget-hurtado-subcontracts', name: 'Subcontratos', category: 'subcontratos', amount: 4000000 },
      { id: 'budget-hurtado-services', name: 'Servicios menores', category: 'servicios_menores', amount: 2000000 },
      { id: 'budget-hurtado-other', name: 'Otros', category: 'otros', amount: 1000000 }
    ]
  }
];

export const renewableProjects = [
  {
    id: 'ren-leyda',
    parkId: 'park-leyda',
    name: 'Parque Solar Atacama Norte',
    technology: 'Solar FV',
    region: 'Antofagasta',
    commune: 'Maria Elena',
    mw: 10,
    stage: 'permisologia',
    rtbProgress: 65,
    responsibleId: null,
    approval: { projectManager: true, purchasingManager: true },
    coordinates: { lat: -23.104, lng: -69.623 }
  }
];

export const renewablePermits = [
  {
    id: 'perm-rca-leyda',
    projectId: 'ren-leyda',
    name: 'RCA - Evaluación Ambiental',
    description: 'Estado de tramitación SEA.',
    type: 'Ambiental',
    status: 'En evaluacion',
    requestDate: '2025-01-10',
    expectedDate: '2026-01-30',
    progress: 45,
    responsible: 'Equipo Desarrollo',
    attachments: []
  }
];

export const renewableRisks = [];
export const renewableMilestones = [];

export const projectStatusProjects = [
  {
    id: 'PRJ-FV-CL-001',
    name: 'Proyecto FV Chile Norte',
    location: 'Región de Atacama, Chile',
    capacityMw: 120,
    description: 'Pipeline IPP/EPC para energía.',
    color: 'emerald'
  }
];

export const projectStatusMatrix = [];
